import { Colors, RawColors } from "../preset.constants";

export const buttonPreset = {
    root: {
        primary: {
            background: Colors.Primary,
            color: RawColors.White,
            border: {
                color: Colors.Primary
            }
        },
        success: {
            background: Colors.SuccessColor,
            color: RawColors.White,
            border: {
                color: Colors.SuccessColor
            }
        },
        secondary: {
            background: Colors.Secondary,
            color: RawColors.White,
            border: {
                color: Colors.Secondary
            }
        },
        info: {
            background: Colors.Info,
            color: RawColors.Black,
            border: {
                color: Colors.Info
            }
        },
        danger: {
            background: Colors.Danger,
            color: RawColors.White,
            border: {
                color: Colors.Danger
            }
        }
    },
    extend: {
        info: {
            color: Colors.Info,
            inverseColor: RawColors.Black
        },
        primary: {
            color: Colors.Primary,
            inverseColor: RawColors.White
        },
        success: {
            color: Colors.SuccessColor,
            inverseColor: RawColors.White
        },
        secondary: {
            color: Colors.Secondary,
            inverseColor: RawColors.Black
        },
        danger: {
            color: Colors.Danger,
            inverseColor: RawColors.White
        }
    },
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    css: ({ dt }: any) => ` 
      .p-button-info {
          background-color: ${dt('button.info.color')};
          color: ${dt('button.info.inverseColor')};
        }
      .p-button-info:not(:disabled):hover  {
          background-color: ${dt('button.info.color')};
          color: ${dt('button.info.inverseColor')};
      }
        .p-button-primary {
          background-color: ${dt('button.primary.color')};
          color: ${dt('button.primary.inverseColor')};
        }
        .p-button-success {
          background-color: ${dt('button.success.color')};
          color: ${dt('button.success.inverseColor')};
        }
        .p-button-secondary {
          background-color: ${dt('button.secondary.color')} ;
          color: ${dt('button.secondary.inverseColor')};
        }
        .p-button-danger {
          background-color: ${dt('button.danger.color')};
          color: ${dt('button.danger.inverseColor')};
        }
    `
}